import { windowDimensions } from "src/util/windowWrapper"
import { ASPECT_RATIO_16_9 } from "../../../constants"
import { DOMEvents } from "../../../constants/domEvents"
import { ElementId } from "../../../constants/enums"

export const SM_FLOATING_WINDOW_SIZE = {
  // for small device
  minWidth: 160,
  minHeight: 90,
  width: 240,
  height: 135,
  maxWidth: 320,
  maxHeight: 180
}

export const LG_FlOATING_WINDOW_SIZE = {
  // for large device
  minWidth: 240,
  minHeight: 135,
  width: 320,
  height: 180,
  maxWidth: 640,
  maxHeight: 360
}

// Add Resizing logic to in app floating video window
export const enableResizeForFloatingVideo = (
  container: HTMLElement,
  transparentOverlay: HTMLElement,
  isSmallDevice = true
) => {
  let startX: number, startWidth: number
  const resizeOverlay = document.getElementById(
    ElementId.FLOATING_VIDEO_RESIZE_ICON
  )

  const floatingWindowSize = isSmallDevice
    ? SM_FLOATING_WINDOW_SIZE
    : LG_FlOATING_WINDOW_SIZE

  function handleResizeStart(event: MouseEvent | Touch) {
    // initialize start value
    startX = event.clientX
    startWidth = container.offsetWidth

    // show transparent fullscreen overlay
    transparentOverlay.style.display = "flex"
    transparentOverlay.style.cursor = "nesw-resize"

    // add the mouse event for resizing
    document.addEventListener(DOMEvents.MOUSEMOVE, handleResizeMouseMove)
    document.addEventListener(DOMEvents.MOUSEUP, handleResizeStop)
    resizeOverlay?.addEventListener(DOMEvents.TOUCHMOVE, handleResizeTouchMove)
    resizeOverlay?.addEventListener(DOMEvents.TOUCHEND, handleResizeStop)
  }

  function handleResizeMove(event: MouseEvent | Touch) {
    // resize the container depending on mouse event position
    // resize should maintain 16:9 ratio

    const width = startWidth + event.clientX - startX
    const height = width / ASPECT_RATIO_16_9

    if (canResize(width, height)) {
      container.style.width = `${width}px`
      container.style.height = `${height}px`
    }

  }

  function canResize(width: number, height: number) {
    // Code to check if the element can be resized
    // Return true if resizable, false otherwise
    
    return ( width > floatingWindowSize.minWidth
      && height > floatingWindowSize.minHeight
      && width < floatingWindowSize.maxWidth
      && height < floatingWindowSize.maxHeight
      && width < window.innerWidth
      && height < windowDimensions.innerHeight 
      // half container should be visible while resizing
      && width / 2 > -container.offsetLeft 
    )
  }

  function handleResizeMouseMove(event: MouseEvent) {
    event.preventDefault()
    handleResizeMove(event)
  }

  function handleResizeTouchMove(event: TouchEvent) {
    event.preventDefault()
    handleResizeMove(event.touches[0])
  }

  function handleResizeMouseStart(event: MouseEvent) {
    event.preventDefault()
    event.stopPropagation()
    handleResizeStart(event)
  }

  function handleResizeTouchStart(event: TouchEvent) {
    event.preventDefault()
    event.stopPropagation()
    handleResizeStart(event.touches[0])
  }

  function handleResizeStop() {
    // hide the fullscreen transparent overlay
    transparentOverlay.style.display = "none"

    // remove the mouse event
    document.removeEventListener(DOMEvents.MOUSEUP, handleResizeStop)
    document.removeEventListener(DOMEvents.MOUSEMOVE, handleResizeMouseMove)
    resizeOverlay?.addEventListener(DOMEvents.TOUCHEND, handleResizeStop)
    resizeOverlay?.removeEventListener(DOMEvents.TOUCHMOVE, handleResizeTouchMove)
  }

  // Add start mouse event listener
  resizeOverlay?.addEventListener(DOMEvents.MOUSEDOWN, handleResizeMouseStart)
  resizeOverlay?.addEventListener(DOMEvents.TOUCHSTART, handleResizeTouchStart)

  return () => {
    // clean up function
    resizeOverlay?.removeEventListener(DOMEvents.MOUSEDOWN, handleResizeMouseStart)
    resizeOverlay?.removeEventListener(DOMEvents.TOUCHSTART, handleResizeTouchStart)
    handleResizeStop()
  }
}
